import { render, staticRenderFns } from "./ListaDepartamentos.vue?vue&type=template&id=5e8d31ae&"
import script from "./ListaDepartamentos.vue?vue&type=script&lang=js&"
export * from "./ListaDepartamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports